import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import SkeletonLoader from "UIComponents/SkeletonLoader";

import classes from "./CohortListSkeleton.scss";

const FULL_ROW_COUNT = 8;
const COMPACT_ROW_COUNT = 2;

const CohortRowSkeleton = () => (
  <div className={classes.row}>
    <SkeletonLoader type="rounded" height="36px" width="36px" />
    <div className={classes.rightContainer}>
      <div className={classes.loaderTextContainer}>
        <SkeletonLoader width="115px" height="12px" type="rounded" />
        <SkeletonLoader width="220px" height="12px" type="rounded" />
      </div>
      <div className={classes.loaderAction}>
        <SkeletonLoader type="rounded" width="18px" height="18px" />
      </div>
    </div>
  </div>
);

const CohortListSkeleton = ({ compact }) => {
  const rowCount = compact ? COMPACT_ROW_COUNT : FULL_ROW_COUNT;
  const containerClass = classNames({
    [classes.container]: !compact,
    [classes.fetchMoreContainer]: compact,
  });
  return (
    <div className={containerClass}>
      {_.times(rowCount, index => (
        <CohortRowSkeleton key={index} />
      ))}
    </div>
  );
};

CohortListSkeleton.propTypes = {
  compact: PropTypes.bool,
};

CohortListSkeleton.defaultProps = {
  compact: false,
};

export default CohortListSkeleton;
